<template>
    <div style="display: flex; flex-direction: column; align-items: center">
        <div style="margin-bottom: 28px">
            <span style="font-size: 22px">立项信息</span>
        </div>
        <div v-if="type !== 'attachment'" class="jdt">
            <div class="jdt-main">
                <div v-for="(item, index) in xmItem" :key="item.index" class="item" :class="{
                    'item-top_item0ea04d': item.status == 1 || item.status == 2
                }">
                    <div class="item-top" :style="{
                        background: item.status == 0 ? '#DEE2E6' : item.status == 1 ? '#ABEDCB' : '#1070CB'
                    }">
                        {{ index + 1 }}
                    </div>
                    <span class="item-text">{{ item.name }}</span>
                </div>
            </div>
        </div>
        <el-form :model="vo" @submit.native.prevent>
            <div style="width: 100%" class="el-table el-table--fit el-table--border">
                <div class="el-table__body-wrapper">
                    <table cellspacing="0" cellpadding="0" border="0" class="el-table__body">
                        <tbody>
                            <tr>
                                <td ref="tdlbl_项目名称" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'flSubject'" class="field">项目名称</span>
                                </td>
                                <td class="el-table__cell tdcont tdw83" colspan="5">
                                    <form-item ref="flSubject" :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: null,
                                        elementType: 'input',
                                        emptyMessage: '请输入项目名称',
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 0,
                                        isRequired: 1,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '项目名称',
                                        propName: 'flSubject',
                                        propType: 'String',
                                        textFormatter: 'textfield',
                                        valueMaxLength: 1000,
                                        valueMinLength: null,
                                        model: 'vo.flSubject',
                                        option: [],
                                        autocomplete: 'off',
                                        dialog: 0,
                                        showWordLimit: false
                                    }" :vo="vo" :can-edit="canEdit" />
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_项目编号" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'tbXmbh'" class="field">项目编号</span>
                                </td>
                                <td class="el-table__cell tdcont tdw33" colspan="2">
                                    <form-item ref="tbXmbh" :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: null,
                                        elementType: 'input',
                                        emptyMessage: '请输入项目编号',
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 0,
                                        isRequired: 1,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '项目编号',
                                        propName: 'tbXmbh',
                                        propType: 'String',
                                        textFormatter: 'textfield',
                                        valueMaxLength: 100,
                                        valueMinLength: null,
                                        model: 'vo.tbXmbh',
                                        option: [],
                                        autocomplete: 'off',
                                        dialog: 0,
                                        showWordLimit: false
                                    }" :vo="vo" :can-edit="canEdit" />
                                </td>
                                <td ref="tdlbl_项目类型" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'tbType'" class="field">项目类型</span>
                                </td>
                                <td class="el-table__cell tdcont tdw33" colspan="2">
                                    <form-item ref="tbType" :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: '1：招标代理\n2：造价咨询\n3：其它',
                                        elementType: 'select',
                                        emptyMessage: '请选择项目类型',
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 0,
                                        isRequired: 1,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '项目类型',
                                        propName: 'tbType',
                                        propType: 'Short',
                                        textFormatter: null,
                                        valueMaxLength: null,
                                        valueMinLength: null,
                                        model: 'vo.tbType',
                                        option: [
                                            { value: '1', name: '招标代理' },
                                            { value: '2', name: '造价咨询' },
                                            { value: '3', name: '其它' }
                                        ],
                                        optionGenerateType: 0,
                                        clearable: false,
                                        filterable: false,
                                        allowCreate: false
                                    }" :vo="vo" :can-edit="canEdit" />
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_投标日期 " class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span v-field-lbl="'tbDate'" class="field">投标日期</span>
                                </td>
                                <td class="el-table__cell tdcont tdw33" colspan="2">
                                    <form-item ref="tbDate" :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: 'format：yyyy年MM月dd日\r\n',
                                        elementType: 'date',
                                        emptyMessage: '请输入投标日期 ',
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 0,
                                        isRequired: 0,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '投标日期 ',
                                        propName: 'tbDate',
                                        propType: 'java.util.Date',
                                        textFormatter: 'yyyy年MM月dd日\r\n',
                                        valueMaxLength: null,
                                        valueMinLength: null,
                                        model: 'vo.tbDate',
                                        option: [],
                                        weekday: 0
                                    }" :vo="vo" :can-edit="canEdit" />
                                </td>
                                <td ref="tdlbl_项目负责人" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'tbXmFzr'" class="field">项目负责人</span>
                                </td>
                                <td class="el-table__cell tdcont tdw83" colspan="5">
                                    <form-item ref="tbXmFzr" :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: null,
                                        elementType: 'input',
                                        emptyMessage: '请输入项目负责人',
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 0,
                                        isRequired: 1,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '项目负责人',
                                        propName: 'tbXmFzr',
                                        propType: 'String',
                                        textFormatter: 'textfield',
                                        valueMaxLength: 1000,
                                        valueMinLength: null,
                                        model: 'vo.tbXmFzr',
                                        option: [],
                                        autocomplete: 'off',
                                        dialog: 0,
                                        showWordLimit: false
                                    }" :vo="vo" :can-edit="canEdit" />
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_计划开始时间 " class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'startDate'" class="field">计划开始时间</span>
                                </td>
                                <td class="el-table__cell tdcont tdw33" colspan="2">
                                    <form-item ref="startDate" :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: 'format：yyyy年MM月dd日\r\n',
                                        elementType: 'date',
                                        emptyMessage: '请输入计划开始时间 ',
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 0,
                                        isRequired: 1,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '计划开始时间 ',
                                        propName: 'startDate',
                                        propType: 'java.util.Date',
                                        textFormatter: 'yyyy年MM月dd日\r\n',
                                        valueMaxLength: null,
                                        valueMinLength: null,
                                        model: 'vo.startDate',
                                        option: [],
                                        weekday: 0
                                    }" :vo="vo" :can-edit="canEdit" />
                                </td>
                                <td ref="tdlbl_计划结束时间 " class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'endDate'" class="field">计划结束时间</span>
                                </td>
                                <td class="el-table__cell tdcont tdw33" colspan="2">
                                    <form-item ref="endDate" :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: 'format：yyyy年MM月dd日\r\n',
                                        elementType: 'date',
                                        emptyMessage: '请输入计划结束时间 ',
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 0,
                                        isRequired: 1,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '计划结束时间 ',
                                        propName: 'endDate',
                                        propType: 'java.util.Date',
                                        textFormatter: 'yyyy年MM月dd日\r\n',
                                        valueMaxLength: null,
                                        valueMinLength: null,
                                        model: 'vo.endDate',
                                        option: [],
                                        weekday: 0
                                    }" :vo="vo" :can-edit="canEdit" />
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_负责人联系电话" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'tbXmFzrPhone'" class="field">负责人联系电话</span>
                                </td>
                                <td class="el-table__cell tdcont tdw33" colspan="2">
                                    <form-item ref="tbXmFzrPhone" :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: null,
                                        elementType: 'input',
                                        emptyMessage: '请输入负责人联系电话',
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 0,
                                        isRequired: 1,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '负责人联系电话',
                                        propName: 'tbXmFzrPhone',
                                        propType: 'String',
                                        textFormatter: 'textfield',
                                        valueMaxLength: 50,
                                        valueMinLength: null,
                                        model: 'vo.tbXmFzrPhone',
                                        option: [],
                                        autocomplete: 'off',
                                        dialog: 0,
                                        showWordLimit: false
                                    }" :vo="vo" :can-edit="canEdit" />
                                </td>
                                <td ref="tdlbl_负责人邮箱" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span v-field-lbl="'tbXmFrzEmail'" class="field">负责人邮箱</span>
                                </td>
                                <td class="el-table__cell tdcont tdw33" colspan="2">
                                    <form-item ref="tbXmFrzEmail" :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: null,
                                        elementType: 'input',
                                        emptyMessage: '请输入负责人邮箱',
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 0,
                                        isRequired: 0,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '负责人邮箱',
                                        propName: 'tbXmFrzEmail',
                                        propType: 'String',
                                        textFormatter: 'textfield',
                                        valueMaxLength: 50,
                                        valueMinLength: null,
                                        model: 'vo.tbXmFrzEmail',
                                        option: []
                                    }" :vo="vo" :can-edit="canEdit" />
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_工期（人天）" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span v-field-lbl="'workDay'" class="field">工期（人天）</span>
                                </td>
                                <td class="el-table__cell tdcont tdw33" colspan="2">
                                    <form-item ref="workDay" :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: null,
                                        elementType: 'input',
                                        emptyMessage: '请输入工期（人天）',
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 0,
                                        isRequired: 0,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '工期（人天）',
                                        propName: 'workDay',
                                        propType: 'Integer',
                                        textFormatter: 'integer',
                                        valueMaxLength: null,
                                        valueMinLength: null,
                                        model: 'vo.workDay',
                                        option: []
                                    }" :vo="vo" :can-edit="canEdit" />
                                </td>
                                <td ref="tdlbl_项目预算金额（元）" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'tbAmount'" class="field">项目预算金额（元）</span>
                                </td>
                                <td class="el-table__cell tdcont tdw33" colspan="2">
                                    <form-item ref="tbAmount" :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: null,
                                        elementType: 'input',
                                        emptyMessage: '请输入项目预算金额（元）',
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 0,
                                        isRequired: 1,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '项目预算金额（元）',
                                        propName: 'tbAmount',
                                        propType: 'java.math.BigDecimal',
                                        textFormatter: 'textfield',
                                        valueMaxLength: null,
                                        valueMinLength: null,
                                        model: 'vo.tbAmount',
                                        option: [],
                                        autocomplete: 'off',
                                        dialog: 0,
                                        showWordLimit: false
                                    }" :vo="vo" :can-edit="canEdit" />
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_项目简介" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span v-field-lbl="'flContent'" class="field">项目简介</span>
                                </td>
                                <td class="el-table__cell tdcont tdw83" colspan="5">
                                    <form-item ref="flContent" :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: 70,
                                        elementCssWidth: null,
                                        elementFormatter: null,
                                        elementType: 'textarea',
                                        emptyMessage: '请输入项目简介',
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 0,
                                        isRequired: 0,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '项目简介',
                                        propName: 'flContent',
                                        propType: 'String',
                                        textFormatter: 'textarea',
                                        valueMaxLength: null,
                                        valueMinLength: null,
                                        model: 'vo.flContent',
                                        option: []
                                    }" :vo="vo" :can-edit="canEdit" />
                                </td>
                            </tr>
                            <tr>
                                <td class="tdlbl tdw100" colspan="6"
                                    style="text-align: left !important; background: #fff !important">
                                    <div>建设单位</div>
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_建设单位" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'projectUnit'" class="field">建设单位</span>
                                </td>
                                <td class="el-table__cell tdcont tdw83" colspan="5">
                                    <form-item ref="projectUnit" :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: null,
                                        elementType: 'input',
                                        emptyMessage: '请输入建设单位',
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 0,
                                        isRequired: 1,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '建设单位',
                                        propName: 'projectUnit',
                                        propType: 'String',
                                        textFormatter: 'textfield',
                                        valueMaxLength: 200,
                                        valueMinLength: null,
                                        model: 'vo.projectUnit',
                                        option: [],
                                        autocomplete: 'off',
                                        dialog: 0,
                                        showWordLimit: false
                                    }" :vo="vo" :can-edit="canEdit" />
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_联系人" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'projectFzr'" class="field">联系人</span>
                                </td>
                                <td class="el-table__cell tdcont tdw33" colspan="2">
                                    <form-item ref="projectFzr" :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: null,
                                        elementType: 'input',
                                        emptyMessage: '请输入联系人',
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 0,
                                        isRequired: 1,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '联系人',
                                        propName: 'projectFzr',
                                        propType: 'String',
                                        textFormatter: 'textfield',
                                        valueMaxLength: 50,
                                        valueMinLength: null,
                                        model: 'vo.projectFzr',
                                        option: []
                                    }" :vo="vo" :can-edit="canEdit" />
                                </td>
                                <td ref="tdlbl_联系电话" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span v-field-lbl="'projectFzrPhone'" class="field">联系电话</span>
                                </td>
                                <td class="el-table__cell tdcont tdw33" colspan="2">
                                    <form-item ref="projectFzrPhone" :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: null,
                                        elementType: 'input',
                                        emptyMessage: '请输入联系电话',
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 0,
                                        isRequired: 0,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '联系电话',
                                        propName: 'projectFzrPhone',
                                        propType: 'String',
                                        textFormatter: 'textfield',
                                        valueMaxLength: 50,
                                        valueMinLength: null,
                                        model: 'vo.projectFzrPhone',
                                        option: []
                                    }" :vo="vo" :can-edit="canEdit" />
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_联系地址" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'projectUnitAddress'" class="field">联系地址</span>
                                </td>
                                <td class="el-table__cell tdcont tdw83" colspan="5">
                                    <form-item ref="projectUnitAddress" :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: null,
                                        elementType: 'input',
                                        emptyMessage: '请输入联系地址',
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 0,
                                        isRequired: 1,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '联系地址',
                                        propName: 'projectUnitAddress',
                                        propType: 'String',
                                        textFormatter: 'textfield',
                                        valueMaxLength: 200,
                                        valueMinLength: null,
                                        model: 'vo.projectUnitAddress',
                                        option: []
                                    }" :vo="vo" :can-edit="canEdit" />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </el-form>

        <!-- 添加一个修改按钮 -->
        <el-button style="margin-top: 20px" type="primary" @click="handleEdit">{{ handleEditTitle }}</el-button>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        vo: {
            type: Object,
            default: function () {
                return {}
            }
        },
        canEdit: { type: Number, default: 0 },

        module: { type: String, default: null }
    },
    data() {
        return {
            attachments: [],
            isAdmin: false,
            handleEditTitle: '修  改',
            xmItem: [
                {
                    index: 1,
                    name: '项目立项',
                    status: 1
                },
                {
                    index: 2,
                    name: '资料借阅申请',
                    status: 0
                },
                {
                    index: 3,
                    name: '资料归还申请',
                    status: 0
                },
                {
                    index: 4,
                    name: '投标保证金申请',
                    status: 0
                },
                {
                    index: 5,
                    name: '标书制作费',
                    status: 0
                }
            ]
        }
    },
    computed: {},
    watch: {},
    created() {
        this.getList()
        const roleList = this.$store.getters.roles
        if (roleList && roleList.indexOf('tbAdministrator') !== -1) {
            this.isAdmin = true
        }
    },
    beforeDestroy() { },
    mounted() {
        this.attachments = this.vo.attachments
    },
    methods: {
        handleEdit() {
            if (this.handleEditTitle === '修  改') {
                this.canEdit = 1
                this.handleEditTitle = '保  存'
            } else {
                this.canEdit = 0
                this.$http({
                    method: 'put',
                    url: '/tbgl/tbxmArch/update',
                    data: this.vo
                }).then((res) => {
                    if (res.code === 'success') {
                        this.$message.success('保存成功')
                    } else {
                        this.$message.error(res.message)
                    }
                })

                this.handleEditTitle = '修  改'
            }
        },
        getList() {
            this.$http({
                method: 'GET',
                contentType: 'application/x-www-form-urlencoded',
                params: { id: this.$route.query.busiDataId },
                url: this.$route.query.wfEngineUrl + '/getProcessById'
            }).then(
                (response) => {
                    if (response.code === 'success') {
                        const tableData = response.body.listdata
                        var uniqueFlTypes = [...new Set(tableData.map((item) => item.flType))]
                        console.log(uniqueFlTypes, 'uniqueFlTypes')
                        uniqueFlTypes.forEach((item) => {
                            this.xmItem.forEach((item2) => {
                                if (item === '发布公告' && item2.name === '公告管理') {
                                    item2.status = 1
                                } else if (item === '结果公示' && item2.name === '结果公告') {
                                    item2.status = 1
                                } else if (item2.name === item) {
                                    item2.status = 1
                                }
                            })
                        })
                        this.xmItem.find((item) => item.name === uniqueFlTypes[uniqueFlTypes.length - 1]).status = 2
                    } else {
                        this.$message.error(response.message)
                    }
                },
                (err) => {
                    console.log(err)
                }
            )
        }
    }
}
</script>

<style scoped lang="scss">
@import '~@/wapp/common/styles/variables.module.scss';

/deep/.el-form .el-table.el-table--border td {
    text-align: left;
}

.jdt {
    width: 100%;

    .jdt-main {
        display: flex;
        justify-content: space-around;
        text-align: center;
    }

    .item {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        width: 20%;
    }

    .item-top {
        width: 40px;
        height: 40px;
        background: #dee2e6;
        color: #fff;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 22px;
        position: relative;
    }

    .item::before {
        content: '';
        width: 50%;
        height: 2px;
        background-image: linear-gradient(to right, #dee2e6 70%, transparent 70%);
        background-size: 4px 1px;
        position: absolute;
        top: 18px;
        z-index: 1;
        right: calc(76% + 0px);
    }

    .item-top_item0ea04d::before {
        background: #4caf50;
        background-image: none !important;
    }

    .item:first-child::before {
        content: '';
        width: 0%;
        height: 2px;
        background-image: linear-gradient(to right, #dee2e6 70%, transparent 70%);
        background-size: 4px 1px;
        position: absolute;
        bottom: 38%;
        z-index: 1;
        right: -108px;
    }

    .item-text {
        font-size: 16px;
        padding: 13px;
    }
}
</style>
